import React, { useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import {
  Add,
  Download,
  Delete,
  Visibility,
  Upload,
  Description,
  PictureAsPdf
} from '@mui/icons-material';

function Documents() {
  const [documents, setDocuments] = useState([
    { id: 1, name: 'Règlement intérieur', type: 'pdf', size: '2.3 MB', date: '2024-01-15', category: 'Règlement' },
    { id: 2, name: 'Guide du locataire', type: 'pdf', size: '5.1 MB', date: '2024-01-10', category: 'Guide' },
    { id: 3, name: 'Attestation assurance', type: 'pdf', size: '156 KB', date: '2024-03-20', category: 'Assurance' },
    { id: 4, name: 'Contrat de location', type: 'pdf', size: '245 KB', date: '2024-01-01', category: 'Contrat' }
  ]);
  const [openDialog, setOpenDialog] = useState(false);

  const getTypeIcon = (type) => {
    switch(type) {
      case 'pdf': return <PictureAsPdf color="error" />;
      default: return <Description />;
    }
  };

  const getCategoryColor = (category) => {
    switch(category) {
      case 'Règlement': return 'primary';
      case 'Guide': return 'info';
      case 'Assurance': return 'warning';
      case 'Contrat': return 'success';
      default: return 'default';
    }
  };

  return (
    <Container maxWidth="xl">
      {/* ✅ MODIFICATION APPLIQUÉE : Container maxWidth="xl" au lieu de "lg" */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          Documents
        </Typography>
        <Button
          variant="contained"
          startIcon={<Upload />}
          onClick={() => setOpenDialog(true)}
        >
          Ajouter un document
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Catégorie</TableCell>
              <TableCell>Taille</TableCell>
              <TableCell>Date d'ajout</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.map((doc) => (
              <TableRow key={doc.id}>
                <TableCell>{getTypeIcon(doc.type)}</TableCell>
                <TableCell>{doc.name}</TableCell>
                <TableCell>
                  <Chip 
                    label={doc.category} 
                    color={getCategoryColor(doc.category)}
                    size="small"
                  />
                </TableCell>
                <TableCell>{doc.size}</TableCell>
                <TableCell>{new Date(doc.date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell>
                  <IconButton size="small" color="primary">
                    <Visibility />
                  </IconButton>
                  <IconButton size="small">
                    <Download />
                  </IconButton>
                  <IconButton size="small" color="error">
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Ajouter un document</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <Button variant="outlined" component="label" fullWidth>
              <Upload sx={{ mr: 1 }} />
              Choisir un fichier
              <input type="file" hidden />
            </Button>
            <TextField fullWidth label="Nom du document" />
            <FormControl fullWidth>
              <InputLabel>Catégorie</InputLabel>
              <Select label="Catégorie">
                <MenuItem value="Règlement">Règlement</MenuItem>
                <MenuItem value="Guide">Guide</MenuItem>
                <MenuItem value="Assurance">Assurance</MenuItem>
                <MenuItem value="Contrat">Contrat</MenuItem>
                <MenuItem value="Autre">Autre</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Annuler</Button>
          <Button variant="contained">Ajouter</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Documents;